import { urlConfig } from '@config/url.config';
import AbstractAPI from './Abstract.api';

export interface IGroup {
    id: string;
    name: string;
    icon: number;
    is_default: boolean;
}

export interface IGetUserGroupsRes {
    groups: IGroup[];
}

export interface ICreateGroupRes {
    id: string;
}

export interface IGroupeDescription {
    name: string;
    icon: number;
}

export class GroupsAPI extends AbstractAPI {
    async getUserGroups(token: string) {
        const pathname = 'group/get';
        const method = 'POST';
        const body: any = {
            token,
        };
        try {
            return await this._request<IGetUserGroupsRes>(
                pathname,
                method,
                body,
            );
        } catch (e) {
            throw new Error(e);
        }
    }
    async createGroup(token: string, name: string, icon: number) {
        const pathname = 'group/create';
        const method = 'POST';
        const body: any = {
            token,
            name,
            icon,
        };
        try {
            return await this._request<ICreateGroupRes>(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async changeGroupDescription(
        token: string,
        group_id: string,
        description: IGroupeDescription,
    ) {
        const pathname = 'group/change_description';
        const method = 'POST';
        const body: any = {
            token,
            group_id,
            description,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async deleteGroup(token: string, id: string) {
        const pathname = 'group/delete';
        const method = 'POST';
        const body: any = {
            token,
            id,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async addDevice(token: string, imei: string, group_id: string) {
        const pathname = 'group/add_device';
        const method = 'POST';
        const body = {
            token,
            imei,
            group_id,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
}

export const groupsAPI = new GroupsAPI(urlConfig);
